import React from "react";

// material-ui
import Grid from "@material-ui/core/Grid";

// jaza-soft
import { TextInput, NumberInput, SelectInput, BooleanInput } from "jazasoft";

// helpers
import { DataType } from "../utils/types";
import { isTrue, isEmpty } from "../utils/helpers";
import getValidation from "../utils/getValidation";

const CustomInputElements = ({ fields, validationRule, i18nKey, labelPrefix }) => {
  if (isEmpty(fields) || isEmpty(validationRule)) return <div />;

  let elementList = fields.map((field, idx) => {
    const validation = validationRule[field] || {};
    let validate = getValidation(validation);
    const disabled = validation?.disabled || false;
    const sm = validation?.sm || 3;
    const label = labelPrefix ? `${labelPrefix}.${field}` : undefined;

    let element;
    switch (validation.dataType) {
      case DataType.TEXT:
        element = (
          <TextInput
            key={idx}
            i18nKey={i18nKey}
            label={label}
            source={field}
            validate={validate}
            disabled={disabled}
            fullWidth
            options={{ fullWidth: true }}
          />
        );
        break;
      case DataType.NUMBER:
        element = (
          <NumberInput
            key={idx}
            i18nKey={i18nKey}
            label={label}
            source={field}
            validate={validate}
            disabled={disabled}
            fullWidth
            options={{ fullWidth: true }}
          />
        );
        break;
      case DataType.BOOLEAN:
        element = (
          <BooleanInput
            key={idx}
            i18nKey={i18nKey}
            label={label}
            source={field}
            validate={validate}
            options={{ disabled }}
            style={{ paddingLeft: "2em", marginTop: "1.5em" }}
          />
        );
        break;
      case DataType.SELECT:
        let multiple = isTrue(validation.multiple);
        let choices = [];
        if (!isEmpty(validation.choices)) {
          choices = validation.choices
            .split(",")
            .map(e => e.trim())
            .map(key => ({ id: key, name: key }));
        }
        element = (
          <SelectInput
            key={idx}
            i18nKey={i18nKey}
            label={label}
            source={field}
            multiple={multiple}
            choices={choices}
            validate={validate}
            disabled={disabled}
            allowEmpty
            fullWidth
            options={{ fullWidth: true }}
          />
        );
        break;
      default:
        element = (
          <TextInput
            key={idx}
            i18nKey={i18nKey}
            label={label}
            source={field}
            validate={validate}
            disabled={disabled}
            fullWidth
            options={{ fullWidth: true }}
          />
        );
    }
    return (
      <Grid key={idx} item xs={12} sm={sm}>
        {element}
      </Grid>
    );
  });
  return <React.Fragment>{elementList}</React.Fragment>;
};

export default CustomInputElements;
